<template>
  <div class="ma-5">
    <titleRA></titleRA>
    <v-btn
      color="primary"
      elevation="0"
      style="margin-top: 8px;"
      absolute
      right
      top
      @click="openReqServiceDialog()"
    >
      <v-icon left size="14px">
        mdi-plus
      </v-icon>
      ร้องขอใช้บริการ
    </v-btn>
    <!-- <v-tabs
      :value="activeTab"
      style="margin-top: -48px;"
      background-color="titlebackground"
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab v-for="item in tabList" :key="item.index" @click="changeTab(item)" class="ml-0 mx-0">
        {{ item.name }}
      </v-tab>

      <v-tabs-items :value="activeTab">
        <v-tab-item>
          <MyServiceList ></MyServiceList>
        </v-tab-item>
        <v-tab-item>
          <RequestServiceList ></RequestServiceList>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs> -->

    <v-tabs
      v-model="tab"
      style="margin-top: -48px;"
      background-color="titlebackground"
    >

    <v-tabs-slider class=""></v-tabs-slider>

    <v-tab v-for="item in tabList" :key="item.index">
      <span class="">{{ item.name }}</span>
    </v-tab>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <MyServiceList ></MyServiceList>
      </v-tab-item>
      <v-tab-item>
        <MyRequestServiceList ></MyRequestServiceList>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
  </div>
</template>

<script>
import { MyServiceList, MyRequestServiceList } from '@/components/index'
import titleRA from '@/components/_authorityservices/title.vue'
import { EventBus } from '@/EventBus'

export default {
  components: {
    MyServiceList, MyRequestServiceList, titleRA
  },
  name: 'overview-service',
  data () {
    return {
      tab: 0,
      renderMyServiceList: true,
      renderRequestServiceList: true,
      tabList: [
        { index: 0, id: 'myservicelist', name: 'บริการที่ใช้งาน' },
        { index: 1, id: 'requestservicelist', name: 'รายการร้องขอใช้บริการ' }
      ]
    }
  },
  mounted () {
  },
  computed: {
    page () {
      return this.$route.params.page || 'myservicelist'
    },
    activeTab () {
      var res = this.$route.params.page === 'myservicelist' ? 0 : this.$route.params.page === 'requestservicelist' ? 1 : 0
      return res
    }
  },
  created () {
  },
  watched: {
  },
  methods: {
    openReqServiceDialog () {
      EventBus.$emit('openReqServiceDialog', this.tab)
    },
    changeTab (item) {
      this.forceRerender()
      // if (item.index !== this.activeTab) this.$router.push(`/authorityservices/${item.id}`)
    },
    forceRerender () {
      if (this.activeTab === 0) {
        this.renderMyServiceList = false
        this.$nextTick(() => {
          this.renderMyServiceList = true
        })
      } else if (this.activeTab === 1) {
        this.renderRequestServiceList = false
        this.$nextTick(() => {
          this.renderRequestServiceList = true
        })
      }
    },
    goPageRequestService () {
      this.$router.push('/authorityservices/myservicelist/create')
    }
  }
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}

.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.v-tab {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: "600";
  font-size: 1.2rem;
}

.v-slide-group__prev {
  display: none !important;
}
</style>
